import PropTypes from 'prop-types';
import React, {Component, Fragment} from "react";
import {connect} from "react-redux";
import PhoneForm from "./PhoneForm";
import LoginForm from "./LoginForm";
import ContractPartnerForm from "./ContractPartnerForm";
import BillingAddressForm from "./BillingAddressForm";
import ContactPersonForm from "./ContactPersonForm";
import AffiliateCodeForm from "./AffiliateCodeForm";
import StepControlButton, {CONTROL_NEXT, CONTROL_PREV} from "../../components/navigation/StepControlButton";
import Collapsible from "../util/Collapsible";
import {Power1, TweenLite} from "gsap";

import * as StepLabels from '../../constants/StepLabels'
import HintWrapper from "../../components/HintWrapper";
import {putFormData} from "../../actions/FormData";
import {forceValidationOnSteps} from "../../actions/StepControl";
import {existingCustomerSelected, newCustomerSelected} from "../../actions/UserAuthentication";
import {getCommissionForm, getContractPartnerForm, getFormLabels, getLoginForm} from "../../selectors/Forms";
import {getAffiliateId} from "../../selectors/GetParam";
import {isClientDataStepValid} from "../../selectors/StepValidation";
import {getBaseArticle, getCartAllowedForCustomerChange, getCartShowCommissionForm} from "../../selectors/SimpleSelectors";
import {isAgencyServer, isNonUsualArticleType} from "../../selectors/ArticleNumbers";
import CollapsingTransitionGroup from "../../components/CollapsingTransitionGroup";

class ClientDataStep extends Component {

    static propTypes = {
        stepLabel: PropTypes.string.isRequired,
        nextLabel: PropTypes.string.isRequired,
        prevLabel: PropTypes.string.isRequired,
        onButtonNextClick: PropTypes.func,
        onButtonPrevClick: PropTypes.func
    }

    handleButtonNextClick = (e) => {

        if (!this.props.clientDataStepValid) {
            this.props.forceValidation()
            this.scrollToTop(null)
        }

        if (this.props.clientDataStepValid && !this.props.isFetchingFormData) {
            this.props.onButtonNextClick()
        }

    }

    static get SCROLL_DURATION() {
        return Math.min(Math.max(0.5, (window.scrollY - 140) / 700), 1)
    }

    scrollToTop = (e) => {

        window.removeEventListener('scroll', this.handleScroll)
        TweenLite.to(window, ClientDataStep.SCROLL_DURATION, {
            scrollTo: {y: 0}, ease: Power1.easeInOut
        })

    }

    componentWillLeave = () => {

        if (this.props.clientDataStepValid && !this.props.isFetchingFormData) {
            this.props.putFormData()
        }

    }

    render() {

        let validationError = null


        if (this.props.isNewCustomerSelected) {

            const phoneDescription = "Neu bei Mittwald? Hast du individuelle Fragen oder Lust auf ein Onboarding mit einem unserer Kundenberater? Wir zeigen dir das Kundencenter inklusive aller Tools & Features. Ganz gleich ob per Telefon oder via Zoom."
            const showError = !this.props.clientDataStepValid && this.props.syncErrors && this.props.forcedValidationSteps.includes(StepLabels.CLIENTDATA)

            if (showError) {
                const formLabels = getFormLabels()
                const errorKeys = Object.keys(this.props.syncErrors);
                const errorFields = errorKeys.map(key => {
                    return formLabels[key]
                }).join(", ");
                validationError = <HintWrapper
                    content={`Bitte korrigiere deine Eingaben in ${errorKeys.length > 1 ? 'den Feldern' : 'dem Feld'}: ` + errorFields}
                    theme="error"
                />
            }

            return (
                <div className="step-display__page clientdata-step">

                    <div className="clientdata-step__clienttype">
                        <button type="button" className="selected">
                            Ich bin Neukunde
                        </button>
                        <button type="button" onClick={(e) => {
                            this.props.existingCustomerSelected()
                        }}>
                            Ich bin bereits Kunde
                        </button>
                    </div>

                    <h1>Vertragspartner</h1>

                    {validationError}

                    <ContractPartnerForm forceValidation={this.props.forcedValidationSteps.includes(StepLabels.CLIENTDATA)}/>

                    {this.props.isAgencyServer ? <Fragment>
                        <h2>Verifizierung</h2>
                        <HintWrapper
                            theme="blue"
                            content={phoneDescription}
                        />
                        <PhoneForm/>
                    </Fragment> : null}

                    {!this.props.initialAffiliate && this.props.showCommissionForm ? <h2>Vermittler / Betreuer verknüpfen</h2> : null}
                    {!this.props.initialAffiliate && this.props.showCommissionForm ? <AffiliateCodeForm forceValidation={this.props.forceValidation} disabled={this.props.isCommissionLocked}/> : null}

                    <Collapsible id="billingAddress" label="Abweichende Rechnungsadresse hinterlegen">
                        <BillingAddressForm forceValidation={this.props.forcedValidationSteps.includes(StepLabels.CLIENTDATA)}/>
                    </Collapsible>

                    {!isNonUsualArticleType(this.props.baseArticle.type) ? <Collapsible id="contactPerson" label="Technischen Ansprechpartner festlegen">
                        <ContactPersonForm forceValidation={this.props.forcedValidationSteps.includes(StepLabels.CLIENTDATA)}/>
                    </Collapsible> : null}


                    <div className="step-display__page__control">
                        {this.props.prevLabel !== "" ? <StepControlButton type={CONTROL_PREV} label={this.props.prevLabel} onClick={this.props.onButtonPrevClick}/> : null}
                        {this.props.nextLabel !== "" ? <StepControlButton disabled={!this.props.clientDataStepValid} type={CONTROL_NEXT} label={this.props.nextLabel} onClick={this.handleButtonNextClick}/> : null}
                    </div>

                </div>

            )
        } else if (this.props.isExistingCustomerSelected) {

            const showError = !this.props.clientDataStepValid && this.props.syncErrorsLogin && this.props.forcedValidationSteps.includes(StepLabels.CLIENTDATA)

            if (showError) {
                const formLabels = getFormLabels("login")
                const errorKeys = Object.keys(this.props.syncErrorsLogin);
                const errorFields = errorKeys.map(key => {
                    return formLabels[key]
                }).join(", ");
                validationError = <HintWrapper
                    content={`Bitte korrigiere deine Eingaben in ${errorKeys.length > 1 ? 'den Feldern' : 'dem Feld'}: ` + errorFields}
                    theme="error"
                />
            }


            return (
                <div className="step-display__page clientdata-step">

                    <div className="clientdata-step__clienttype">
                        <button type="button" onClick={(e) => {
                            this.props.newCustomerSelected()
                        }}>
                            Ich bin Neukunde
                        </button>
                        <button type="button" className="selected">
                            Ich bin bereits Kunde
                        </button>
                    </div>

                    <h1>Vertragspartner</h1>

                    <CollapsingTransitionGroup>
                        {validationError}
                    </CollapsingTransitionGroup>

                    <LoginForm forceValidation={this.props.forcedValidationSteps.includes(StepLabels.CLIENTDATA)}/>

                    <div className="step-display__page__control">
                        {this.props.prevLabel !== "" ? <StepControlButton type={CONTROL_PREV} label={this.props.prevLabel} onClick={this.props.onButtonPrevClick}/> : null}
                        {this.props.nextLabel !== "" ? <StepControlButton onMouseOver={() => {
                            if (!this.props.clientDataStepValid) {
                                this.props.forceValidation()
                            }
                        }} disabled={!this.props.clientDataStepValid || this.props.isFetchingClientData} type={CONTROL_NEXT} label={this.props.nextLabel} onClick={this.handleButtonNextClick}/> : null}
                    </div>
                </div>
            )
        }
    }
}

const mapStateToProps = (state, ownProps) => {


    const syncErrorsPartner = getContractPartnerForm(state) && getContractPartnerForm(state).syncErrors;
    const syncErrorsCommission = getCommissionForm(state) && getCommissionForm(state).syncErrors;

    const syncErrors = {...syncErrorsPartner, ...syncErrorsCommission};

    return {
        clientDataStepValid: isClientDataStepValid(state),
        isFetchingFormData: state.appState.isFetchingFormData,
        showCommissionForm: getCartShowCommissionForm(state),
        forcedValidationSteps: state.ui.forcedValidationSteps,
        isExistingCustomerSelected: state.clientDataStep.existingCustomerSelected,
        isNewCustomerSelected: state.clientDataStep.newCustomerSelected,
        existingUserAuthenticated: state.clientDataStep.existingUserAuthenticated,
        initialAffiliate: getAffiliateId(state),
        isFetchingClientData: state.clientDataStep.isFetchingClientData,
        syncErrors: syncErrors,
        syncErrorsLogin: getLoginForm(state) ? getLoginForm(state).syncErrors : {},
        isCommissionLocked: state.cart && state.cart.isCommissionLocked,
        isAllowedForCustomerChange: getCartAllowedForCustomerChange(state),
        baseArticle: getBaseArticle(state),
        isAgencyServer: isAgencyServer(getBaseArticle(state).articleNumber),
    }
}


const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        putFormData: () => {
            dispatch(putFormData())
        },
        forceValidation: () => {
            dispatch(forceValidationOnSteps([ownProps.stepLabel]))
        },
        existingCustomerSelected: () => {
            dispatch(existingCustomerSelected())
        },
        newCustomerSelected: () => {
            dispatch(newCustomerSelected())
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps, null, {withRef: true})(ClientDataStep)



/** WEBPACK FOOTER **
 ** ./src/containers/clientdata/ClientDataStep.js
 **/